module.exports = __webpack_public_path__ + "static/media/Billsbot-Down.a4356e59.svg";